import type { SearchFieldProps } from '@launchpad-ui/components';
import { Group, IconButton, Input, ProgressBar, SearchField } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import styles from './TagSearchField.module.css';

interface TagSearchFieldProps extends SearchFieldProps {
  isPending: boolean;
}

export function TagSearchField({ isPending, ...props }: TagSearchFieldProps) {
  return (
    <SearchField {...props} aria-label="Search tags" autoFocus>
      <Group>
        <Icon name="search" size="small" />
        <Input placeholder="Search tags" />
        {isPending && (
          <span className={styles.progressBar}>
            <ProgressBar aria-label="Loading…" isIndeterminate size="small" />
          </span>
        )}
        <IconButton aria-label="clear" icon="cancel-circle-outline" size="small" variant="minimal" />
      </Group>
    </SearchField>
  );
}
